import { Account, UserSettings } from "../../../_app/types";
import { Box } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../../store/store";
import { switchAccount } from "../../../store/slices/userSlice";
import { showNotification } from "../../../store/slices/notificationSlice";
import { HubError } from "../../../class/Error";
import { useNavigate } from "react-router-dom";
import Spacer from "../../../_components/Spacer";
import AccountList from "../../../_modules/Header/AccountList";
import IconComponent from "../../../components/ui/IconComponent";
import { useApi } from "../../../_hooks/use-api";
import MyButton from "../../../_components/MyButton";
import { useTranslation } from "react-i18next";
import { FC } from "react";

interface AccountCenterProps {
  accounts: Account[];
}

const AccountCenter: FC<AccountCenterProps> = ({ accounts }) => {
  const dispatch = useDispatch();
  const user = useSelector((state: RootState) => state.user);
  const api = useApi();
  const { t } = useTranslation("account");
  const navigate = useNavigate();

  const handleSwitchAccount = async (value: Account) => {
    let settings: UserSettings[] = [
      { name: "ACTIVE_ACCOUNT_ID", value: value.id, format: "STRING" },
    ];
    try {
      await api.updateUserSettings(user.profile.profileId, settings);
      dispatch(
        showNotification({
          message: `Account ${user.activeAccount.name} switched`,
          severity: "info",
        })
      );
      dispatch(switchAccount(value));
    } catch (error: any) {
      error instanceof HubError
        ? dispatch(
            showNotification({
              message: `${error.message} ${error.detailedMessage}`,
              severity: "error",
            })
          )
        : dispatch(showNotification({ message: error.message, severity: "error" }));
    }
  };

  const viewMarketList = () => navigate("/account/add");

  return (
    <Box className="layout">
      <Box className="layout-fixed-wrapper" sx={{ paddingBottom: "20px" }}>
        <MyButton
          onClick={viewMarketList}
          variant="secondary"
          endIcon={<IconComponent iconName={"Plus"} hasStroke hasFill />}
        >
          {t("connectAccount")}
        </MyButton>
      </Box>

      <Box className="layout-content-wrapper">
        <AccountList
          accounts={accounts}
          activeAccount={user.activeAccount.id}
          onChangeAccount={handleSwitchAccount}
        />

        <Spacer height="40px" />
      </Box>
    </Box>
  );
};

export default AccountCenter;
